import axios from 'axios'
import Vue from 'vue'

import is from '../web/plugins/helper/is'
import { NetworkOnly } from './networkOnly'

let timer = null
let timer2 = null
let newTime = null

const RequestServiceHelper = {
  methods: {
    cleanWhenSelectingProject() {
      this.$store.commit('GET_HOUSES_CONTRACTS_START')
    },
    async listsProject() {
      await this.$store.dispatch('getProjects')
    },
    async getTypeContract() {
      await this.$store.dispatch('getTypeContracts')
    },
    async getListsContractor() {
      await this.$store.dispatch('getContractors')
    },
    async getTypePayments(params) {
      await this.$store.dispatch('getTypePayments', params ?? {})
    },
    /**
     * @param {String} name
     * @param {Object} extraParams
     */
    async getUsers(name, extraParams) {
      if (!this.isObject(extraParams)) {
        extraParams = {}
      }
      await this.$store.dispatch('getUsers', { name, ...extraParams })
    },
    async getUser(userId) {
      await this.$store.dispatch('getUser', userId)
    },
    async getBankTypes() {
      await this.$store.dispatch('getBankTypes')
    },
    async getBankAccountTypes() {
      await this.$store.dispatch('getBankAccountTypes')
    },
    async getbankAccountTypeAccounts() {
      await this.$store.dispatch('getbankAccountTypeAccounts')
    },
    async getRoles() {
      await this.$store.dispatch('getListRoles')
    },
    async getTypeListUser() {
      await this.$store.dispatch('getTypeListUsers')
    },
    async getOrganizationalRoleType() {
      await this.$store.dispatch('getOrganizationalRoleType')
    },
    async getBankPaymentTypes(params) {
      await this.$store.dispatch('getBankPaymentTypes', params ?? {})
    },
    async getContractForProjectID(projectId) {
      await this.$store.dispatch('getContractForProjectID', { projectId })
    },
    async getPaymentTypeModules() {
      await this.$store.dispatch('getPaymentTypeModules')
    },
    cancelProcess(name) {
      this.$router.push({ name })
    },
    /**
     * @param {Object} model
     */
    setearInformacion(model) {
      this.editForm.keys().forEach(key => {
        if (this.checkVariable(model, model[key])) {
          this.editForm[key] = model[key]
        }
      })
    },
    /**
     * @param {Number} projectId
     * @param {Number} typeContract
     * @param {Array} rows
     */
    async markActiveContract(projectId, typeContract, rows) {
      this.$store.dispatch('getHouseContracts', { projectId, typeContract })

      if (this.checkVariable(timer)) {
        clearInterval(timer)
      }

      const promise = new Promise(resolve => {
        timer = setInterval(
          () => {
            if (this.getHousesContracts && this.getHousesContracts.length > 0) {
              resolve(this.getHousesContracts)
            }
          },
          500,
        )
      })
      promise.then(response => {
        rows.forEach(newRows => {
          const rowsTypeContract = this.noReactive(this.getAllAssociatedValues(newRows, 'tipo_contrato_id', 'name'))
          if (rowsTypeContract && rowsTypeContract.length > 0) {
            rowsTypeContract.forEach(row => {
              if (row.name === 'tipo_contrato_id' && this.getValueNumber(row.value) === this.getValueNumber(typeContract)) {
                const rowsContract = this.getAllAssociatedValues(newRows, 'contrato_id', 'name')
                if (rowsContract && rowsContract.length > 0) {
                  rowsContract.forEach(contract => {
                    this.$set(contract, 'option', response)
                    if (!this.checkVariable(contract.value)) {
                      const first = this.getTheFirst(response)
                      this.$set(contract, 'value', this.getObjectValue(first, 'value'))
                    }
                  })
                }
              }
            })
          }
        })
        clearInterval(timer)
      })
    },
    async getAccountingAccount(type) {
      let params = {}
      if (this.checkVariable(type)) {
        params = type
      }
      await this.$store.dispatch('getAccountingAccounts', params)
    },
    async getProjectBankAccounts(projectId, withSelection) {
      await this.$store.dispatch('getProjectBankAccounts', { projectId, withSelection })
    },
    async notifyChangeHousingSelection(projectId, houseId) {
      await this.$store.dispatch('getContractForHousingAndProjectID', { projectId, houseId })
    },
    async getHouses(projectId) {
      await this.$store.dispatch('getHouses', { projectId })
    },
    async getHousesByContract(contractId) {
      await this.$store.dispatch('getHousesByContract', { contractId })
    },
    async getContractingParties() {
      await this.$store.dispatch('getContractingParties')
    },
    async searchAgent() {
      await this.$store.dispatch('getInspectors')
    },
    async listPeriod() {
      await this.$store.dispatch('getPeriods')
    },
    async getContracts(searchText) {
      await this.$store.dispatch('getContracts', searchText)
    },
    async getBlueprints(params) {
      await this.$store.dispatch('getBlueprints', params)
    },
    async updateTotalAmountPayJobs(params) {
      await this.$store.dispatch('updateTotalAmountPayJobs', params)
    },
    async getLotsByPreContract(params, id) {
      await this.$store.dispatch('getLotsByPreContract', params, id)
    },
    async getSalesProjectModels() {
      await this.$store.dispatch('getSalesProjectModels')
    },
    async getBatchTypes() {
      await this.$store.dispatch('getBatchTypes')
    },
    /**
     * @param {Object} params
     */
    async getModelComments(params) {
      await this.$store.dispatch('getModelComments', params)
    },
    /**
     * @param {Object} params
     */
    async getStatusEntry(params) {
      await this.$store.dispatch('getStatusEntry', params)
    },
    getWritingStatus() {
      this.$store.dispatch('getWritingStatus')
    },
    /**
     * @param {Object} params
     */
    getRooms(params) {
      return this.$store.dispatch('getRooms', ((this.checkVariable(params)) ? params : {}))
    },
    /**
     * @param {Object} params
     */
    getRoomsMessages(params) {
      return this.$store.dispatch('getRoomsMessages', ((this.checkVariable(params)) ? params : {}))
    },
    actionGetRoomMessages(sid, params) {
      this.$store.dispatch('getRoomMessages', { sid, params })
    },
    actionGetRoomActiveMessages(sid, params) {
      this.$store.dispatch('getRoomActiveMessages', { sid, params })
    },
    getRoomActive(sid) {
      this.$store.dispatch('getRoomActive', sid)
    },
    getCurrentRoom(sid) {
      this.$store.dispatch('getRoom', sid)
    },
    getRoomHistory(sid) {
      this.$store.dispatch('getRoomHistory', sid)
    },
    actionAddRoomMessages(sid, params) {
      this.$store.dispatch('addRoomMessages', { sid, params })
    },
    eventUpdateReaction({ reaction, remove, messageId, roomId }) {
      this.$store.dispatch('eventUpdateReaction', { reaction, remove: (remove) ? 'remove' : 'add', messageId, roomId })
    },
    getLastCustomerActions(params={}) {
      this.$store.dispatch('getLastCustomerActions', params)
    },
    /**
     * @param {String} name
     * @param {Object} extraParams
     */
    async getLawyers(name, extraParams) {
      if (!this.isObject(extraParams)) {
        extraParams = {}
      }
      await this.$store.dispatch('getLawyers', { name, ...extraParams })
    },
    /**
     * @param {String} name
     * @param {Object} extraParams
     */
    getLawyersUser(name, extraParams) {
      this.$store.dispatch('getLawyersUser', { name, ...extraParams })
    },
    /**
     * @param {String} sid
     * @param {Object} params
     */
    notifyRoomChange(sid, params) {
      this.$store.dispatch('notifyRoomChange', { sid, params})
    },
    /**
     * @param {String} sid
     * @param {Object} params
     */
    registerSubscriptionConversation(sid, params) {
      this.$store.dispatch('registerSubscriptionConversation', { sid, params})
    },
    /**
     * @param {Array} services
     * @return {Array}
     */
    createFormatToGenerateTableTinyBox(services) {
      const newService = []
      if (this.isArray(services)) {
        services.forEach(service => {
          let contractId = null
          let contractIdTexto = null
          if (service.tipo_contrato_id === 1) {
            contractId = this.getObjectValue(this.getTheFirst(service.servicio_caja_menuda_job_casa), 'id')
            contractIdTexto = this.getObjectValue(this.getTheFirst(service.servicio_caja_menuda_job_casa), 'nombre')
          } else if (service.tipo_contrato_id === 2) {
            contractId = this.getObjectValue(this.getTheFirst(service.servicio_caja_menuda_job_infra), 'id')
            contractIdTexto = this.getObjectValue(this.getTheFirst(service.servicio_caja_menuda_job_infra), 'nombre')
          }

          newService.push({
            id: service.id,
            tipo_contrato_id: service.tipo_contrato_id,
            cuenta_contable_id: service.cuenta_contable_id,
            contrato_id: contractId,
            contratista_id: service.contratista_id,
            descontar: service.descontar,
            numero_factura: service.numero_factura,
            detalle: service.detalle,
            precio: service.precio,
            impuesto: service.impuesto,
            contrato_id_texto: contractIdTexto,
            files: [],
          })
        })
      }

      return newService
    },
    /**
     * @param {Array} services
     * @param {Array} columns
     * @return {Array}
     */
    getFormatToGenerateTableTinyBox(services, columns) {
      let getHousesContracts = this.getHousesContracts
      if (
        this.checkVariable(getHousesContracts) &&
        this.isArray(getHousesContracts) &&
        getHousesContracts.length === 0
      ) {
        if (this.isArray(services) && services.length > 0) {
          const temp = []
          services.forEach(service => {
            temp.push({
              value: service.contrato_id,
              text: service.contrato_id_texto,
            })
          })
          getHousesContracts = temp
        }
      }

      return this.noReactive(
        this.newAssignment({
          template: 'tiny_box',
          defaultName: columns,
          prefix: '',
          values: services,
          defaultValues: {
            impuesto: [
              { value: 0, text: '0%', default: '' },
              { value: 7, text: '7%' },
            ],
            tipo_contrato_id: {
              tag: 'select',
              runServer: false,
              value: this.typeContracts,
              useReferenceEvent: true,
            },
            contrato_id: getHousesContracts,
            cuenta_contable_id: {
              tag: 'select',
              runServer: false,
              useReferenceEvent: false,
              value: this.accountingAccounts,
            },
            contratista_id: {
              tag: 'select',
              value: this.contractors,
            },
            descontar: [
              { value: 'Si', text: 'Si', default: 'No' },
              { value: 'No', text: 'No' },
            ],
          },
          keysForList: [
            'tipo_contrato_id',
            'contratista_id',
            'contrato_id',
            'cuenta_contable_id',
            'impuesto',
            'descontar',
            'files',
          ],
          editableOptions: {
            editable: true,
            inspeccion: true,
            disabled: (this.isArray(services) && services.length > 0),
            keysDisabled: ['tipo_contrato_id', 'contrato_id'],
          },
        }),
      )
    },
    async listUsers(user) {
      if (user && user.length >= 1) {
        await this.getUsers(user, { tipo_usuario_id: 1 })
      }
    },
    /**
     * @return {Promise}
     */
    async currentInspeccion() {
      const self = this
      const auth = self.authUser

      return await new Promise((resolve, reject) => {
        if (!self.checkVariable(newTime)) {
          clearInterval(newTime)
        }
        newTime = setInterval(
          () => {
            try {
              if (self.determinesInspectionAction(['forceInspectionTable'])) {
                clearInterval(newTime)
                resolve(true)
              }
              if (
                !self.determinesInspectionAction(['forceInspectionTable']) &&
                self.checkVariable(self.createForm) &&
                self.determinesInspectionAction(['invoiceTableInspection'])
              ) {
                clearInterval(newTime)
                resolve(true)
              }
              if (
                !self.determinesInspectionAction(['forceInspectionTable']) &&
                self.checkVariable(self.editForm) &&
                self.checkVariable(self.editForm.responsable_id)
              ) {
                clearInterval(newTime)
                resolve(auth.id === self.editForm.responsable_id)
              }
            } catch (error) {
              clearInterval(newTime)
              reject(error)
            }
          },
          100,
        )
      })
    },
    /**
     * @param {Array} requests
     * @return {Boolean}
     */
    createBankObject(requests) {
      if (!this.checkVariable(this.rows)) {
        return false
      }
      if (!this.checkVariable(requests)) {
        requests = [{ 'id': 0 }]
      }

      const nombres = ['tipo_banco_id', 'nombre', 'tipo_cuenta_contable_banco_id', 'numero']
      this.rows = this.noReactive(
        this.newAssignment({
          template: 'users',
          defaultName: nombres,
          prefix: '',
          values: requests,
          defaultValues: {
            tipo_banco_id: this.bankTypes,
            tipo_cuenta_contable_banco_id: this.bankAccountTypeAccounts,
          },
          keysForList: ['tipo_banco_id', 'tipo_cuenta_contable_banco_id'],
          inputValueType: {
            numero: {
              type: 'string',
            },
            nombre: {
              type: 'string',
            },
          },
          idDefault: 0,
        }),
      )
    },
    /**
     * @param {Array} records
     * @return {Array}
     */
    initialFormatObjectsInvoicesAndChecks(records) {
      if (!this.isArray(records)) {
        return []
      }
      const all = []
      records.forEach(record => {
        if (this.checkVariable(record) && this.checkVariable(record.comentarios) && this.isArray(record.comentarios)) {
          const comment = this.getTheFirst(record.comentarios)
          record.comentarios = this.checkVariable(comment) ? comment.descripcion : ''
        }
        all.push(record)
      })

      return all
    },
    /**
     * @param {Object} row
     * @param {Object} force
     * @return {Object}
     */
    combineIndicatedObjectForPaymentsInput(row, force) {
      const request = {
        editable: row.editable,
        id: row.id,
        lugar: row.lugar,
        name: row.name,
        parent_id: row.parent_id || null,
        tag: 'input',
        value: row.value,
        visible: row.visible,
        type: row.type || null,
      }
      if (this.checkVariable(row.id_reference)) {
        request.id_reference = row.id_reference
      }

      return this.merge(request, force)
    },
    /**
     * @param {Object} row
     * @param {Object} force
     * @return {Object}
     */
    combineIndicatedObjectForPaymentsSelect(row, force) {
      const request = {
        aprobado: row.aprobado,
        editable: row.editable,
        id: row.id,
        lugar: row.lugar,
        name: row.name,
        option: [],
        parent_id: row.parent_id || null,
        tag: 'select',
        value: row.value,
        visible: row.visible,
        type: row.type || null,
      }
      if (this.checkVariable(row.id_reference)) {
        request.id_reference = row.id_reference
      }

      return this.merge(request, force)
    },
    createOptimizedObjectRequest(rows, data) {
      if (!this.checkVariable(data)) {
        return []
      }

      const temp = []
      switch (data.value) {
        case 2:
          rows.forEach(row => {
            if ((this.checkVariable(row.name, row.tag) && row.name === 'banco_id') && (row.tag === 'select' || row.tag === 'input')) {
              temp.push(this.combineIndicatedObjectForPaymentsInput(row, { editable: true }))
            } else {
              temp.push(row)
            }
          })
          break
        case 3:
          rows.forEach(row => {
            if ((this.checkVariable(row.name, row.tag) && row.name === 'banco_id') && (row.tag === 'select' || row.tag === 'input')) {
              temp.push(this.combineIndicatedObjectForPaymentsInput(row, { editable: false, value: '' }))
            } else {
              temp.push(row)
            }
          })
          break
        case 4:
          rows.forEach(row => {
            if ((this.checkVariable(row.name, row.tag) && row.name === 'banco_id') && (row.tag === 'select' || row.tag === 'input')) {
              temp.push(this.combineIndicatedObjectForPaymentsInput(row, { editable: false, value: '' }))
            } else {
              temp.push(row)
            }
          })
          break
        default:
          const options = this.checkVariable(this.bankAccounts) ? this.bankAccounts : []
          rows.forEach(row => {
            if (this.checkVariable(row.name, row.tag) && row.name === 'banco_id' && row.tag === 'input') {
              temp.push(this.combineIndicatedObjectForPaymentsSelect(row, { option: options }))
            } else {
              temp.push(row)
            }
          })
          break
      }
      const result = this.getAllAssociatedValues(temp, 0, 'id')
      if (this.checkVariable(result) && this.isArray(result) && result.length > 0) {
        result.forEach(row => {
          if (row.name !== 'tipo_pago_banco_id' && this.isString(row.value)) {
            this.$set(row, 'value', '')
          }
          if (row.name !== 'tipo_pago_banco_id' && !Number.isNaN(row.value)) {
            this.$set(row, 'value', '')
          }
        })
      }

      return temp
    },
    /**
     * @param {Array} columns
     * @param {Array} datos
     * @param {Object} defaultValues
     * @param {Array} keysForList
     */
    getRowsChecks(columns, datos, defaultValues, keysForList) {
      const typeDate = ['fecha']
      const defaultRowsChecks = this.newAssignment({
        template: 'cheques',
        defaultName: columns,
        prefix: '',
        values: datos,
        defaultValues,
        keysForList,
        typeDate,
        inputValueType: {
          banco_id: {
            type: 'string',
          },
          numero_cheque: {
            type: 'string',
          },
          banco_cheque: {
            type: 'string',
          },
        },
        idDefault: 0,
      })
      const rowsCheck = this.inspectBillAndPayments(defaultRowsChecks, datos)
      if (rowsCheck && rowsCheck.length > 0) {
        this.rowsChecks = this.noReactive(rowsCheck)
      } else {
        this.rowsChecks = this.noReactive(defaultRowsChecks)
      }
      if (this.checkVariable(this.rowsChecks) && this.isArray(this.rowsChecks)) {
        const tempNewRows = []
        this.rowsChecks.forEach(rows => {
          const row = this.getTheFirst(this.getAllAssociatedValues(rows, 'tipo_pago_banco_id', 'name'))
          if (this.checkVariable(row)) {
            const newRows = this.createOptimizedObjectRequest(rows, row)
            tempNewRows.push(newRows)
          }
        })
        if (tempNewRows.length > 0) {
          this.rowsChecks = this.clone(tempNewRows)
        }
      }
      this.takeCareOfVerifyingPayment(this.rowsChecks, datos)
    },
    calculateTotalPayAndInvoice(netCharge) {
      if (!this.checkVariable(this.createSummaryForm)) {
        return null
      }
      if (!isNaN(netCharge)) {
        const { pagos_a_la_fecha: toPay } = this.createSummaryForm
        let timer = null
        const _this = this
        const promise = new Promise(resolve => {
          timer = setInterval(() => {
            const checkTotal = _this.formattedValueRetracement(_this.checkTotalNoWithoutAdvance)
            if (checkTotal >= 0 && _this.rowsChecks && _this.rowsChecks.length > 0) {
              clearInterval(timer)
              resolve(checkTotal)
            }
          }, 100)
        })
        promise.then(async total => {
          _this.totalToBill = _this.formattedValueRetracement(netCharge)
          _this.totalToPay = ((_this.formattedValueRetracement(toPay) + _this.formattedValueRetracement(netCharge)) - total)

          await this.updateTotalAmountPayJobs({
            path: _this.jobRoute,
            id: _this.checkVariable(_this.contract) ? _this.contract.id : null,
            params: { total_bill: _this.totalToBill, total_pay: _this.totalToPay },
          })
        })
      }
    },
    /**
     * @param {Object} params
     */
    menuPeriod(params) {
      const self = this
      if (!self.checkVariable(params)) {
        return null
      }
      const { proyecto_id: proyectoId, method } = params
      const text = proyectoId ? this.$t('open_period_text') : this.$t('warning_open_period_text')
      self.defaultSettingsSwal()
      const toast = self.setupSwal()
      toast.fire({
        title: self.$t('confirmar'),
        text,
        confirmButtonText: this.$t('open_period_confirmation'),
        preConfirm: () => {
          if (self.checkVariable(method) && method === 'patch') {
            return axios.patch(params.url_action, params)
          }

          return axios.post(params.url_action, params)
        },
      }).then(
        async ({ value }) => {
          if (self.checkVariable(value) && value.status === 200) {
            self.defaultSettingsToastSwal()
            self.swalTitle = self.$t('contracts')
            self.swalText = self.$t('open_period_confirmation_result')
            self.positionedDialogToast()
            await self.$store.dispatch('setUpdateStatus', params)
          }
        },
      )
    },
    async closedContract(messages) {
      const self = this
      if (!self.checkVariable(messages)) {
        return null
      }
      self.defaultSettingsSwal()
      const toast = self.setupSwal()
      toast.fire({
        title: this.$t(messages.titleMessage),
        text: this.$t(messages.closeContractMessage),
        confirmButtonText: this.$t(messages.openText),
        preConfirm: () => {
          return self.editContractStatusFrom.patch(`${messages.route}/${self.editContractStatusFrom.id}`)
        },
      }).then(
        ({ value }) => {
          if (self.checkVariable(value) && value.status === 200) {
            self.defaultSettingsToastSwal()
            self.swalTitle = self.$t(messages.titleMessage)
            self.swalText = self.$t(messages.closeContratoResult)
            self.positionedDialogToast()
            self.$store.dispatch('setUpdateStatus', { data: value.data, ...messages })
          }
        },
      )
    },
    async closeContract(contract) {
      this.editContractStatusFrom.id = contract.id
      this.editContractStatusFrom.estado_id = 4 // Finiquito
      this.editContractStatusFrom.proyecto_id = contract.proyecto_id
      this.closedContract({
        titleMessage: 'close_contrat',
        closeContractMessage: 'close_contract_message',
        openText: 'close_text',
        closeContratoResult: 'close_contrato_result',
        route: this.route.routeCloseContract,
      })
    },
    async openClosedContract(contract) {
      this.editContractStatusFrom.id = contract.id
      this.editContractStatusFrom.estado_id = 1 // Abrir
      this.editContractStatusFrom.proyecto_id = contract.proyecto_id
      this.closedContract({
        titleMessage: 'open_contract',
        closeContractMessage: 'open_contract_message',
        openText: 'open_text',
        closeContratoResult: 'open_contrato_result',
        route: this.route.routeOpenClosedContract,
      })
    },
    /**
     * @param {Object} messages
     */
    async accountOpeningProcess(messages) {
      const self = this
      if (!self.checkVariable(messages) || !this.checkVariable(self.route)) {
        return null
      }
      self.$set(self.closeAccountFrom, 'itIsGreat', true)
      self.defaultSettingsSwal()
      const toast = self.setupSwal()
      toast.fire({
        title: self.$t('confirmar'),
        text: messages.text,
        preConfirm: () => {
          return axios.patch(`${self.route.routeAccountClosure}/${self.closeAccountFrom.id}`, self.closeAccountFrom)
        },
      }).then(({ value, dismiss }) => {
        if (self.checkVariable(value) && value.status === 200) {
          self.defaultSettingsToastSwal()
          self.swalTitle = self.$t('contracts')
          self.swalText = messages.confirmation_result
          self.positionedDialogToast()
          self.$set(self.closeAccountFrom, 'itIsGreat', false)
          self.$store.dispatch('setUpdateStatus', { ...self.closeAccountFrom, ...messages })
        }
        if (self.checkVariable(dismiss) && dismiss === 'cancel') {
          self.$set(self.closeAccountFrom, 'itIsGreat', false)
        }
      },
      )
    },
    /**
     * @param {Object} contract
     */
    async closeBudgetMenu(contract) {
      const self = this
      if (!self.checkVariable(contract) || !this.checkVariable(self.budgetStatusFrom) || !this.checkVariable(self.route)) {
        return null
      }
      self.budgetStatusFrom['itIsGreat'] = true
      self.budgetStatusFrom.id = contract.id
      if (contract.estado_presupuesto) {
        self.budgetStatusFrom.estado_presupuesto = false
      }
      self.defaultSettingsSwal()
      const toast = self.setupSwal()
      toast.fire({
        title: self.$t('confirmar'),
        text: self.$t('confirmation_close_budget'),
        confirmButtonText: this.$t('confirmation_action_close_budget'),
        preConfirm: () => {
          return axios.post(`${self.route.routeBudgetStatus}/${contract.id}`, self.budgetStatusFrom)
        },
      }).then(
        ({ value, dismiss }) => {
          if (self.checkVariable(value) && value.status === 200) {
            self.defaultSettingsToastSwal()
            self.swalTitle = self.$t('contracts')
            self.swalText = self.$t('confirmation_result_close_budget')
            self.positionedDialogToast()
            self.$set(self.budgetStatusFrom, 'itIsGreat', false)
            self.$store.dispatch('setUpdateStatus', contract)
          }
          if (self.checkVariable(dismiss) && dismiss === 'cancel') {
            self.$set(self.budgetStatusFrom, 'itIsGreat', false)
          }
        },
      )
    },
    /**
     * @param {Object} model
     * @return {Boolean}
     */
    checkInvoiceInspection(model) {
      const inspection = this.determinesInspectionAction(['forceInspectionTable'])
      if (inspection === true) {
        return true
      }

      const checkVar = this.checkVariable(model)
      const days = (checkVar === true) ? this.getDifferenceInDays(this.inspectionStartDate) : 0
      if (checkVar === true && this.determinesInspectionAction(['invoiceTableInspection']) && [1, 3, 5].indexOf(model.estado_material_id) === -1 && days <= 90) {
        return true
      }

      return checkVar === true && this.determinesInspectionAction(['invoiceTableInspection']) && [1, 3, 4, 5].indexOf(model.estado_material_id) === -1
    },
    /**
     * @param {Object} model
     * @return {Boolean}
     */
    checkCheckInspection(model) {
      const inspection = this.determinesInspectionAction(['forceInspectionTable'])
      if (inspection === true) {
        return true
      }

      const checkVar = this.checkVariable(model)

      return checkVar === true && this.determinesInspectionAction(['checkTableInspection']) && [1, 3, 4, 5].indexOf(model.estado_material_id) === -1
    },
    /**
     * @return {Promise}
     */
    _loadingEventPusherRequest() {
      const _this = this
      if (_this.checkVariable(timer2)) {
        clearInterval(timer2)
      }
      let count = 0

      return new Promise(resolve => {
        timer2 = setInterval(
          () => {
            if (count >= 100) {
              clearInterval(timer2)
              resolve(false)
            }
            if (!_this.checkVariable(_this.errorEventPusherRequest) && _this.loadingEventPusherRequest === false) {
              clearInterval(timer2)
              resolve(true)
            }
            count++
          },
          0,
        )
      })
    },
    /**
     * @param {Object} data
     */
    _triggerPusherRequestEvent({ model, path, broadcast_as, channel }) {
      const id = this.isNumber(model) ? model : model.id
      this.$store.dispatch(
        'setEventPusherRequest',
        {
          echo: this.Echo,
          url: path,
          broadcast_as,
          channel: this.replace(channel, '{$id}', id),
        },
      )
    },
    /**
     * @param {Object} data
     */
    setEventPusherRequest({ model, path, broadcast_as, channel }) {
      const _this = this
      if (!_this.checkVariable(model)) {
        return false
      }

      const loading = _this._loadingEventPusherRequest()
      const promise = _this.$refs.loadingComponent.load(loading)
      promise.then(re => {
        if (re === false) {
          _this._triggerPusherRequestEvent({ model, path, broadcast_as, channel })
        }
      })

      _this._triggerPusherRequestEvent({ model, path, broadcast_as, channel })
    },
    /**
     * @param {Object} data
     */
    setEventPusherRequestWithPromise({ property, path, broadcast_as, channel }) {
      const id = this.getObjectValue(this.$route.params, property)
      if (!this.checkVariable(id)) {
        return false
      }

      this.setEventPusherRequest({ model: id, path: `${path}/${id}/pusher`, broadcast_as, channel })
    },
    /**
     * @return {Promise}
     */
    checkSocketConnection() {
      const appUrl = is.getValueSetting('echoServerHost')
      const port = is.getValueSetting('echoServerPort')

      return NetworkOnly.handle(`${appUrl}:${port}`)
    },
    /**
     * @param {Array} optionList
     * @return {Array}
     */
    getValuesOfOptionsList(optionList) {
      if (this.isArray(optionList) && optionList.length > 0) {
        return optionList.map(object => object.value)
      }

      return []
    },
    /**
     * @param {Array} optionList
     * @return {Array}
     */
    getValuesAndDisabledOfOptionsList(optionList) {
      if (this.isArray(optionList) && optionList.length > 0) {
        return optionList.map(object => {
          return {
            value: object.value,
            $isDisabled: this.getBoolValue(object.disabled),
          }
        })
      }

      return []
    },
    /**
     * @param {Array} optionList
     * @param {String} option
     * @return {String}
     */
    getLabelOfOptionList(optionList, option) {
      if (this.isArray(optionList) && optionList.length > 0) {
        const foundObject = optionList.find(currentOption => currentOption.value === option)

        if (this.checkVariable(foundObject)) {
          return foundObject.text
        }
      }

      return null
    },
    /**
     * @param {Mixed} value
     * @param {Array} selectedOptions
     * @return {Boolean}
     */
    multiselectOptionSelected(value, selectedOptions = null) {
      if (!this.checkVariable(selectedOptions)) {
        selectedOptions = this.selectedLotsValues
      }

      const searchResult = this.getFirstOccurrence(selectedOptions, value)

      if (this.checkVariable(searchResult)) {
        return true
      }

      return false
    },
    /**
     * @param {Number} id
     * @param {String} message
     * @param {String} path
     * @return {Promise}
     */
    markWithOrWithoutIntervention(id, message, path) {
      const self = this
      self.defaultSettingsSwal()
      const toast = self.setupSwal()
      toast.fire({
        title: self.$t('confirmar'),
        text: message,
        confirmButtonText: this.$t('yes_confirm'),
        cancelButtonText: this.$t('not_confirm'),
        preConfirm: () => {
          return axios.post(`/api/administrations/users/${id}/${path}`)
        },
      }).then(
        ({ value }) => {
          if (self.checkVariable(value) && value.status === 200) {
            self.defaultSettingsToastSwal()
            self.swalTitle = self.$t('contracts')
            self.swalText = self.$t('confirmation_result_close_budget')
            self.positionedDialogToast()
            self.$store.dispatch('setUpdateStatus', self.generateRandomNumber(10))
          }
        },
      )

      return toast
    },
    async setMarkAsPaid(path, aprobado, confirmButtonText) {
      this.defaultSettingsSwal()
      const swal = this.setupSwal()

      return swal.fire({
        title: this.$t('title_mark_as_paid_module'),
        text: this.$t('message_confirm_as_paid_module'),
        confirmButtonText,
        showCancelButton: true,
        showConfirmButton: true,
        preConfirm: () => {
          return axios.patch(path, { aprobado }).catch(err => {
            this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))

            return err
          })
        },
      }).then(response => {
        if (this.checkVariable(response) && this.checkVariable(response.isConfirmed) && response.isConfirmed) {
          this.defaultSettingsToastSwal()
          this.swalTitle = this.$t('update_response')
          this.swalText = undefined
          this.positionedDialogToast()
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        } else if (this.checkVariable(response) && this.checkVariable(response.isDismissed) && !response.isConfirmed) {
          this.$store.dispatch('setUpdateStatus', this.generateRandomNumber(10))
        }

        return response
      })
    },
    /**
     * @return {void}
     */
    fillGlobalTotalColumnsRequests() {
      this.filterable.globalTotalColumns = [
        { key: 'global_total_request', text: this.$t('total_request'), column: 'total_solicitud' },
        { key: 'global_total_invoice', text: this.$t('total_invoices'), column: 'total_factura_fiscal' },
        { key: 'global_total_check', text: this.$t('total_checks'), column: 'total_cheques_pagado' },
        { key: 'global_total_payable_invoice', text: this.$t('total_by_pay_invoice'), column: 'total_por_pagar_facturado' },
        { key: 'global_total_payable_request', text: this.$t('total_by_pay_request'), column: 'total_por_pagar_solicitud' },
      ]
    },
    /**
     * @param {Number} id
     * @param {String} message
     * @param {String} path
     * @return {Promise}
     */
    generateSecretKeyUser(id, message) {
      const self = this
      self.defaultSettingsSwal()
      const toast = self.setupSwal()

      return toast.fire({
        title: self.$t('secret_key'),
        text: message,
        confirmButtonText: this.$t('yes_confirm'),
        cancelButtonText: this.$t('not_confirm'),
        preConfirm: () => {
          return axios.post(`/api/administrations/users/${id}/generate_secret_key`)
        },
      }).then(({ value }) => {
        if (self.checkVariable(value) && value.status === 200) {
          self.defaultSettingsToastSwal()
          self.swalTitle = self.$t('secret_key')
          self.swalText = self.$t('update_response')
          self.positionedDialogToast()
          self.$store.dispatch('setUpdateStatus', self.generateRandomNumber(10))
        }
      },
      )
    },
  },
}

const Component = Vue.extend({
  name: 'new-request-service-helper',
  mixins: [RequestServiceHelper],
})

export default Component
